import * as React from "react";
import Layout from "./Layout";
import { Container, Typography } from "@mui/material";

const PodminkyPage = () => {
    return (
        <Layout>
            <Container maxWidth={"md"}>
                <Typography component="h1" variant="h4" gutterBottom>
                    Podmínky soutěže
                </Typography>
                <ul>
                    <li>
                        Soutěžící je povinen absolvovat celou trasu pouze za
                        pomoci vlastní síly a úsilí, a to pouze za pomoci chůze
                        nebo běhu.
                    </li>
                    <li>Soutěžící se účastní akce na vlastní nebezpečí.</li>
                    <li>
                        Soutěžící může každou etapu absolvovat v libovolném
                        opakování. Do hodnocení mu však bude vždy započítán
                        pouze jeden pokus a to ten nejrychlejší.
                    </li>
                    <li>
                        Soutěžící musí absolvovat trasu se zařízením umožňující
                        záznam GPS souřadnic v čase (obecně je tato funkce známá
                        jako gps logger nebo také gps tracker).
                    </li>
                    <li>
                        Soutěžící musí takto pořízený GPS záznam z průběhu trasy
                        etapy uložit pomocí aplikace strava (na webových
                        stránkách www.strava.com nebo pomocí mobilní aplikace
                        Strava pro Android nebo iOS). Tento uložený záznam musí
                        být viditelný pro ostatní uživatele (nesmí být soukromý)
                        a musí obsahovat příslušný “segment” určený pro danou
                        výzvu.
                    </li>
                    <li>
                        Pořadatel bude po ukončení termínu soutěže (nejpozději
                        do 10 dnů) kontaktovat vítěze přes systém strava.com. V
                        případě, kdy se vyhlašovaný neozve do 5 dnů, má
                        pořadatel právo oslovit s výhrou dalšího soutěžícího v
                        pořadí.
                    </li>
                    <li>
                        Účastí v soutěži vyjadřuje soutěžící souhlas s pravidly
                        soutěže a zavazuje se je plně dodržovat. Účastí v
                        soutěži souhlasí soutěžící se zařazením všech jím
                        poskytnutých osobních údajů v rámci této akce (dále jen
                        „údaje”) do databáze Město Jeseník, IČO 00302724,
                        Masarykovo nám. 167/1, jakožto správce (dále v tomto
                        odstavci jen „město“), a s jejich následným zpracováním
                        pro účely prověření platné účasti v akci a k odběru
                        marketingových sdělení a to po dobu trvání tohoto
                        souhlasu. Soutěžící bere na vědomí, že má práva dle §
                        11, 21 zák. č. 101/2000 Sb., tj. zejména že poskytnutí
                        údajů je dobrovolné, že svůj souhlas může bezplatně a
                        písemně kdykoliv na adrese města odvolat, má právo
                        přístupu k osobním údajům a právo na opravu těchto
                        osobních údajů, blokování nesprávných osobních údajů,
                        jejich likvidaci, atd.
                    </li>
                    <li>
                        Pořadatel si vyhrazuje právo bez udání důvodu vyloučit
                        účastníka akce, jehož chování vykazuje známky nekalého
                        či podvodného jednání. Pořadatel neodpovídá za přímé či
                        nepřímé škody v souvislosti s účastí akci. Pořadatel
                        akce neručí za jakékoliv technické problémy v
                        souvislosti s účastí v akci.
                    </li>
                    <li>
                        Pořadatel si vyhrazuje právo ze závažných důvodů akci
                        přerušit nebo zrušit či změnit její pravidla. V případě,
                        že dojde ke změnám v podmínkách a pravidlech akce, bude
                        toto učiněno ve formě dodatku a zveřejněno webových
                        stránkách města. Účinnost této změny nastává okamžikem
                        zveřejnění dle předchozí věty. Pořadatel akce si
                        vyhrazuje právo konečného posouzení splnění či nesplnění
                        podmínek stanovených pro účast v akci.
                    </li>
                </ul>
            </Container>
        </Layout>
    );
};

export default PodminkyPage;
